import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'development',
    templateUrl: './development.component.html',
    styleUrls: ['./development.component.scss'],
    standalone: false
})
export class DevelopmentComponent implements OnInit {

	constructor() {
	}

	ngOnInit(): void {
	}


}

